/**
 * Intelligence Prism Helpers (DC-1368)
 *
 * SVG path calculation and driver type classification.
 * Extracted from IntelligencePrism.tsx.
 */

import type { DriverType } from './types';

/** Generate a sigmoid (S-curve) Bezier path between two points */
export const getSigmoidPath = (
  startX: number,
  startY: number,
  endX: number,
  endY: number,
  tension: number = 0.5
): string => {
  const delta = endX - startX;
  const controlPoint1X = startX + delta * tension;
  const controlPoint2X = endX - delta * tension;

  return `M ${startX} ${startY}
          C ${controlPoint1X} ${startY},
            ${controlPoint2X} ${endY},
            ${endX} ${endY}`;
};

/**
 * Map Pistoia driver names to L0 driver types (Cost, Speed, Quality, Effectiveness).
 * DC-1098: Added governance value driver mappings.
 */
export const getDriverType = (driverName: string | undefined | null): DriverType => {
  if (!driverName || typeof driverName !== 'string') return 'EFFECTIVENESS';
  const name = driverName.toLowerCase();

  // DC-1098: Governance value drivers
  if (name.includes('governance maturity')) return 'EFFECTIVENESS';
  if (name.includes('compliance maturity')) return 'QUALITY';
  if (name.includes('risk reduction')) return 'EFFECTIVENESS';
  if (name.includes('accountability clarity')) return 'SPEED';

  if (name.includes('cost') || name.includes('savings') || name.includes('efficiency')) return 'COST';
  if (name.includes('time') || name.includes('speed') || name.includes('cycle') || name.includes('fast') || name.includes('accelerat')) return 'SPEED';
  if (name.includes('quality') || name.includes('compliance') || name.includes('accuracy')) return 'QUALITY';
  return 'EFFECTIVENESS';
};

/** DC-1098: Check if a driver is a governance driver */
export const isGovernanceDriver = (driverName: string | undefined | null): boolean => {
  if (!driverName || typeof driverName !== 'string') return false;
  const name = driverName.toLowerCase();
  return name.includes('governance maturity') ||
         name.includes('compliance maturity') ||
         name.includes('risk reduction') ||
         name.includes('accountability clarity') ||
         name.includes('governance') ||
         name.includes('raci') ||
         name.includes('policy') ||
         name.includes('stewardship');
};
